<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- main content -->
    <!-- Header Component -->
    <div>
      <HeaderComponent :headerTitle="headerText" :router-link="{ name: 'ErrorListing' }"
        :router-link-text="action_title" :return-condition="true" :component-name="apiName" />
    </div>

    <!--  view error log popup -->
    <v-row justify="center">
      <v-dialog v-model="viewErrorLogPopup" persistent max-width="900px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Error Log(Voltas CRM Inbound) <span style="font-size:10px;font-weight:600;color:#9C9C9C;">Creation Date: 12/04/2024 12:10PM</span></span>
            <v-spacer></v-spacer>
            <v-btn icon @click="viewErrorLogPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-left">
            <!-- <h6>{{this.error_log_data}}</h6> -->
            <v-row>
            <v-col cols="12" sm="3" md="3">
              <strong>Request Payload :</strong>
            </v-col>
             <v-col cols="12" sm="9" md="9">
             {{this.request_log}}
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" sm="3" md="3">
             <strong>Response Payload :</strong>
            </v-col>
             <v-col cols="12" sm="9" md="9">
             {{this.response_log ? this.response_log : this.error_log_data}}
            </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  add comment popup -->
    <v-row justify="center">
      <v-dialog v-model="addCommentPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span v-if="this.comment_data">Comments (Voltas CRM Inbound)</span>
            <span v-else>Add Comment</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="addCommentPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center" v-if="isViewComment == false">
            <v-textarea v-model="newComment" rows="10" required cols="50" label="Add comment" height="100"  variant="outlined"> </v-textarea>
          </v-card-text>
          <v-card-actions class="margin-10 d-flex justify-center block" v-if="isViewComment == false">
            <v-btn small class="text-none" variant="outlined" text color="normal" @click="addCommentPopup = false">Cancel</v-btn>
            <v-btn small variant="flat" class="text-none" color="primary" @click="submitComment()">Submit</v-btn>
          </v-card-actions>
          <v-container v-if="isViewComment == true">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <span class="ma-2">{{this.comment_data ? this.comment_data : 'No Comment Found'}}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-3p" v-model="filtersPopup" persistent max-width="1224px">
        <v-card>
          <v-card-actions>
            <v-text-field v-model="filterErrorType" prepend-inner-icon="mdi-magnify" item-title="name" item-value="id"
              class="ma-2"  variant="outlined" label="Error Type" style="max-width:300px;"></v-text-field>
            <v-combobox v-model="filterErrorCode" prepend-inner-icon="mdi-magnify" :items="errorCodeData" item-title="name"
              item-value="id" label="Error Code"  variant="outlined" class="ma-2" style="max-width:300px;"></v-combobox>

            <v-menu ref="menu_16" v-model="menu_16" :close-on-content-click="false" :return-value.sync="filter_date"
              transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field  variant="outlined" v-model="filter_date" label="Date" prepend-inner-icon="event" readonly
                  v-bind="attrs" v-on="on" style="max-width: 
                      300px;" class="ma-2"></v-text-field>
              </template>
              <v-date-picker v-model="filter_date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text class="text-none"  color="primary" @click="menu_16 = false">Cancel</v-btn>
                <v-btn text variant="flat" color="primary" @click="$refs.menu_16.save(filter_date)">Ok</v-btn>
              </v-date-picker>
            </v-menu>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small class="text-none" variant="outlined" text color="normal" @click="cancelFilterpopup">Cancel</v-btn>
            <v-btn small variant="flat" class="text-none"  color="primary" @click="applyFilterFunc()">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- For showing Filters and Action buttons -->
    <v-card-title class="action-style pb-2 mt-6" style="padding: 28px;">
      <v-row>
        <v-col cols="3" sm="3">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="item_search" label="Search" style="max-width: 300px;"
             variant="outlined" v-on:keyup.enter="loadData()"></v-text-field>
        </v-col>
      <v-spacer></v-spacer>
        <v-expansion-panels class="custom-control_outlined pt-3" readonly
          style="max-width: 300px; height: 56px;">
          <v-expansion-panel  variant="outlined" @click="listFiltersData">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table :dense="true" density="compact" return-object v-model="selected" show-select disable-pagination :hide-default-footer="true"
          :headers="headers" :items="table_data" :loading="loading" fixed-header height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1">
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'error_log'">
                <a @click="itemDetailpopup(item)" style="color: #1976d2;">
                  <u>View</u>
                </a>              
              </span> 
              <span v-else-if="header.key == 'created_at'">
                {{ item.created_at ? formatTimestamp(item.created_at) : '-'}}
              </span> 
              <span v-else-if="header.key == 're_trigger'">
                <v-btn class="m-2" label="RE-TRIGGER" :disabled="true"  variant="outlined" color="primary"  v-if="item.re_trigger"
                   style="color: #1976d2;">RE-TRIGGERED</v-btn>
                <v-btn class="m-2" label="RE-TRIGGER"  variant="outlined" color="primary" @click="retrigger(item, index)" v-if="!item.re_trigger"
                   style="color: #1976d2;">RE-TRIGGER</v-btn>              
               </span> 
              <span v-else-if="header.key == 'comments'">
                  <a @click="openCommentpopup(item)" style="color: #1976d2;" v-if="item.comments">
                    <u> View Comment </u>
                  </a>
                  <a @click="openCommentpopup(item)" style="color: #1976d2;" v-else>
                    <u> Add Comment</u>
                  </a>              
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.api_name`]="{ item }">
            {{ item.api_name ? item.api_name : "-"}}
          </template> -->
          <!-- <template #[`item.error_type`]="{ item }">
            {{ item.error_type ? item.error_type : '-'}}
          </template> -->
          <!-- <template #[`item.error_code`]="{ item }">
            {{ item.error_code ? item.error_code : '-'}}
          </template> -->
          <!-- <template #[`item.error_log`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2;" v-if="item.error_log">
              <u>View</u>
            </a>
            <span v-else>-</span>
          </template> -->
          <!-- <template #[`item.created_at`]="{ item }">
            {{ item.created_at ? formatTimestamp(item.created_at) : '-'}}
          </template> -->
          <!-- <template #[`item.ageing`]="{ item }">
            {{ item.ageing ? item.ageing : '-'}}
          </template> -->
          <!-- <template #[`item.re_trigger`]="{ item }">
            <v-btn class="m-2" label="RE-TRIGGER" :disabled="true"  variant="outlined" color="primary"  v-if="item.re_trigger"
              style="color: #1976d2;">RE-TRIGGERED</v-btn>
            <v-btn class="m-2" label="RE-TRIGGER"  variant="outlined" color="primary" @click="retrigger(item, index)" v-if="!item.re_trigger"
              style="color: #1976d2;">RE-TRIGGER</v-btn>
          </template> -->
          <!-- <template #[`item.comments`]="{ item }" >
            <a @click="openCommentpopup(item)" style="color: #1976d2;" v-if="item.comments">
              <u> View Comment </u>
            </a>
            <a @click="openCommentpopup(item)" style="color: #1976d2;" v-else>
              <u> Add Comment</u>
            </a>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>

           <div>
                <v-row class="ml-2 pb-4">
                    <span class="PaddingItemPerPage d-flex mt-4">
                        <label class="" style="margin-top: -2px;">Rows Per Page</label>
                        <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                        variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
                    </span>
                    <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                        v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
                    <v-spacer></v-spacer>
                    <div class="d-flex">
                        <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                        - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                        <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                        <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                        @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                        </span>
                    </div>
                </v-row>
            </div>
  </v-card>
</template>
<script>
import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';

export default {
  data() {
    return {
      headerText: 'Error Handling',
      alert_type: 'success',
      alert_message: '',
      alert: false,
      selected: [],
      loading: false,
      action_title: 'API Level',
      apiName: '',
      headers: [
        { title: "API Name", key: "api_name", sortable: false },
        // { title: "API Description", key: "api_description", sortable: false },
        // { title: "Error Type", key: "error_type" },
        { title: "Error Code", key: "error_code" },
        { title: "Error Log", key: "error_log" },
        { title: "Date & Time", key: "created_at" },
        { title: "Ageing", key: "ageing" },
        { title: "Re-Trigger", key: "re_trigger" },
        { title: "Comment", key: "comments" },

      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: 100,
      pageSizes: [50, 100, 150],
      item_search: '',
      filtersPopup: false,
      filter_date: '',
      filterErrorType: '',
      menu_16: false,
      filterErrorCode: '',
      errorCodeData: [],
      viewErrorLogPopup: false,
      addCommentPopup: false,
      isTriggeredBtn: false,
      isViewComment: false,
      newComment: '',
      comment_data: '',
      error_log_data: '',
      request_log:'' ,
      response_log:'',
    }
  },
  components: {
    HeaderComponent
  },
  async created() {
    this.apiName = this.$store.state.actionRequest;
    // const item_detail = JSON.stringify(this.$store.state.items.api_payloads);
    // const item_pages = this.$store.state.items.meta;
    // this.item_pages = item_pages
    // this.item_detail = item_detail
    this.organization_name = this.$store.state.organization_name
    this.loadData()
    this.scrollToTop();
  },
  methods: {
    listFiltersData(ev) {
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.item_search = '';
      this.filtersPopup = true;
      this.filter_date = '';
      this.filterStage = '';

    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handlePageChange(value) {
      this.page = value;
      if (this.isFiltering) {
        this.filterPage = value;
        this.applyFilterFunc();
        return;
      }
      this.mainData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.filterPage = 1;
      if (this.isFiltering) {
        this.applyFilterFunc();
        return;
      }
      this.mainData();
    },
    getRequestParams(page, pageSize, filterPageNo) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (filterPageNo) {
        params["filterPageNo"] = filterPageNo
      }
      return params;
    },
    cancelFilterpopup() {
      this.filtersPopup = false;
      this.filter_date = '';
      this.filterStage = '';
    },
    loadData() {
      this.loading = true;
      this.selected = []
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.pageSize = 100
      this.filterPageNo = 1
      this.isFilteringPage = false
      this.headers = [
        { title: "API Name", key: "api_name", sortable: false },
        // { text: "Error Type", key: "error_type" },
        { title: "Code", key: "error_code" },
        { title: "Logs", key: "error_log" },
        { title: "Date & Time", key: "created_at" },
        { title: "Ageing", key: "ageing" },
        { title: "Re-Trigger", key: "re_trigger" },
        { title: "Comment", key: "comments" },
      ];
      this.mainData();
    },
    mainData(){
    const params = new URLSearchParams();
    params.append('page', this.page);
    params.append('per_page', this.pageSize);
    params.append('filter[payload_type]', this.apiName);
    this.$httpSecured
      .get("/api/v2/api_payloads/", { params: params })
      .then(response => {
        if (response.data) {
          this.table_data = response.data.api_payloads
          this.totalPages = response.data.meta.total_pages
          this.totalCount = response.data.meta.total_count
          this.loading = false;
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
        }
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
      });
    },
    applyFilterFunc(){
      const params = new URLSearchParams();
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      params.append('search', this.item_search);
      params.append('filter[date]', this.filter_date);
      params.append('filter[error_code]', this.filterErrorCode);

      const requestParams = params;
      this.$httpSecured
        .get("/api/v2/api_payloads", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_payloads
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filter_date = '';
            this.filterErrorCode = '';
            this.filterStatus = '';
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      let hour = date.getHours();
      const minute = date.getMinutes();
      const amPM = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
      return `${day}/${month}/${year}, ${formattedTime}`;
    },
    itemDetailpopup(item) {
      this.error_log_data = item.error_log ? item.error_log.error_message : "No error message available";
      this.request_log = item.request_payload;
      this.response_log = item.response_payload;
      this.viewErrorLogPopup = true;
    },
    retrigger(item) {
      this.$httpSecured
        .post(`/api/v2/api_payloads/${item.id}/retry`)
        .then(response => {
          if (response.data) {
            this.$toast.success(response.data.message);
            this.$set(item, 're_trigger', true);   
            setTimeout(() => {
              this.$set(item, 're_trigger', false); 
            }, 300000);
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message)
          this.loading = false;
        });
    },
    openCommentpopup(item) {
      this.comment_data = item.comments
      this.addCommentPopup = true;
      this.comment_data ? this.isViewComment = true : this.isViewComment = false;
      this.selected = item
    },
    submitComment() {
      const item_id = this.selected.id
      const requestParams = {
        comments: this.newComment
      };
      this.$httpSecured
        .put(`/api/v2/api_payloads/${item_id}/update_comment`, requestParams)
        .then(response => {
          if (response.data) {
            this.addCommentPopup = false;
            this.isViewComment = true;
            this.selected = [];
            this.showAlert('success', response.data.message);
            this.fetchingErrorListingData();
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          // this.showAlert('error', error.response.data.message)
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      
    },
    fetchingErrorListingData() {
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      const requestParams = {
        page: params.page,
        per_page: params.size,
      };
      this.$httpSecured
        .get("/api/v2/api_payloads?filter[status]=failed", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
  }
}
</script>
<style scoped>
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
    .v-dialog:has(.filter-3p){
      justify-content: right;
      align-items: baseline;
      top: var(--dialog-ypos);
    }
  .v-menu__content {
    min-width: 300px !important;
  }
  .v-dialog>.v-card>:has(.v-card__title){
  overflow-wrap: break-word !important;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 303px) !important;
  }
</style>